import type { BusinessCustomerPayload, RegulatorInformation } from 'types/customers'
import { getFormattedSingleDateValue } from 'utils/date'
import type { AddBusinessCustomerV2FormData } from './types'

export const buildAddBusinessCustomerPayload = (
  data: AddBusinessCustomerV2FormData
): BusinessCustomerPayload => {
  const showOperationalAddress = data.isOperationalAddressDifferent === 'true'
  const isRegulated = data.isRegulated === 'true'
  const regulatorInformation: RegulatorInformation | undefined =
    isRegulated && data.regulatorName && data.regulatorJurisdiction
      ? { regulatorName: data.regulatorName, regulatorJurisdiction: data.regulatorJurisdiction }
      : undefined

  return {
    useCase: data.useCase,
    company: {
      name: data.name,
      entityType: data.entityType,
      registrationNumber: data.registrationNumber,
      address: {
        addressLine1: data.registeredAddressLine1,
        city: data.registeredAddressCity,
        postalCode: data.registeredAddressPostalCode,
        countryCode: data.registeredAddressCountryCode,
      },
      isOperationalAddressDifferent: showOperationalAddress,
      taxIdentification: {
        number: data.taxNumber,
        taxResidenceCountryCode: data.taxResidenceCountryCode,
      },
      businessProfile: {
        naicsCode: data.naicsCode,
        monthlyExpectedVolumes: data.monthlyExpectedVolumes,
        isRegulated,
        sourceOfFunds: data.sourceOfFunds,
        intendedUseOfAccount: data.intendedUseOfAccount,
        website: data.website,
        ...(regulatorInformation && { regulatorInformation }),
      },
      ...(showOperationalAddress && {
        operationalAddress: {
          addressLine1: data.operationalAddressLine1,
          city: data.operationalAddressCity,
          postalCode: data.operationalAddressPostalCode,
          countryCode: data.operationalAddressCountryCode,
        },
      }),
      incorporationDate: getFormattedSingleDateValue(data.incorporationDate),
      businessOperationsStartDate: getFormattedSingleDateValue(data.businessOperationsStartDate),
    },
  }
}
